module.exports = __webpack_public_path__ + "img/ghost.642d1056.svg";